export default "__VITE_ASSET__KbP2ZoCz__"